<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background"
        :show="installmentloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-alert
            variant="danger"
            :show="!signature && installmentData.length > 0"
            class="mb-1"
          >
            <div
              v-if="linkSentDate && isWithin24HoursFunction(linkSentDate)"
              class="alert-body"
            >
              <feather-icon

                icon="InfoIcon"
                class="mr-50"
              />
              {{ $t('DEBTOR_HAS_NOT_SIGNED') }} <label class="orange-text">{{ $t('SIGNATURE_SENT_WITHIN_24_HOURS') }}</label>.
            </div>
            <div
              v-else
              class="alert-body"
            >
              <feather-icon

                icon="InfoIcon"
                class="mr-50"
              />
              {{ $t('DEBTOR_HAS_NOT_SIGNED_PLEASE') }} <b-link @click="sendLink">
                {{ $t('CLICK_HERE') }}
              </b-link> {{ $t('SIGNATURE_LINK') }}
            </div>
          </b-alert>
          <b-card-header
            class="installment-plan-header"
          >
            <b-card-title>{{ $t('DEBTIA_INSTALLMENT_PLAN') }}</b-card-title>
            <b-card-title class="text-primary">
              <b-button
                v-if="$ability.can(constants.action.permissionCancelAgreementPlan, constants.resource.user) && !isSuperAdmin && installmentplanstatus === 1 && installmentData.length > 0"
                id="cancel-plan-btn"
                variant="primary"
                @click="confirmText"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_CANCEL_PLAN') }}</span>
              </b-button>
              <!-- <drag-links
                :parent="4"
                :side="side"
                :custom-change="customChange"
              /> -->
            </b-card-title>
          </b-card-header>
          <b-card-body
            class="installment-plan-body"
          >
            <div
              v-if="installmentData.length > 0"
              class="scroll-div-installment"
            >
              <b-table
                :fields="installmentTableFields"
                :items="installmentData"
                striped
              >
                <template #cell(amount)="row">
                  {{ `${formatCurrency(row.item.installment_amount, defaultCurrency)}` }}
                </template>
                <template #cell(interest)="row">
                  {{ `${formatCurrency(row.item.interest, defaultCurrency)}` }}
                </template>
                <template #cell(remaining_amount)="row">
                  {{ `${formatCurrency(row.item.remaining_amount, defaultCurrency)}` }}
                </template>
                <template #cell(status)="row">
                  <b-badge
                    v-if="row.item.is_paid"
                    variant="success"
                    class="badge-glow"
                  >
                    {{ $t('DEBTIA_PAID') + ' (' + row.item.payment_date + ')' }}
                  </b-badge>
                  <b-badge
                    v-else-if="!row.item.is_paid && row.item.failed_reasons !== null"
                    variant="danger"
                    class="badge-glow"
                  >
                    {{ row.item.failed_reasons }}
                  </b-badge>
                  <b-badge
                    v-else
                    variant="warning"
                    class="badge-glow"
                  >
                    {{ $t('DEBTIA_NOT_PAID') }}
                  </b-badge>
                </template>
              </b-table>
            </div>
            <b-alert
              v-else
              variant="warning"
              show
            >
              <div class="alert-body">
                {{ $t('DEBTIA_NO_PLAN_GENERATED_MSG') }}
              </div>
            </b-alert>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BAlert, BTable, BCardBody, BOverlay, BButton, BLink,
  BBadge,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'
import axios from '@axios'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BOverlay,
    BLink,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BButton,
    BBadge,
    // DragLinks,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      installmentloader: true,
      installmentData: [],
      installmentplanstatus: 404,
      userType: JSON.parse(localStorage.getItem('userData')).data.user_type,
      isSuperAdmin: false,
      caseId: this.$route.params.id,
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      signature: false,
      linkSentDate: null,
      isWithin24Hours: false,
      communications_client_id: '',
      communications_secret: '',
      sender_email: '',
      generate_signature_link_email_template_id: 0,
      payment_client_id: '',
      payment_secret: '',
    }
  },
  computed: {
    installmentTableFields() {
      return [
        { key: 'installment_date', label: i18n.t('DEBTIA_INSTALLMENT_DATE') },
        { key: 'interest', label: i18n.t('DEBTIA_INSTALLMENT_INTEREST') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ]
    },
  },
  // setup() {
  //   const { installmentData, installmentplanstatus, userType } = store.state['case-details']
  //   let isSuperAdmin = false
  //   if (userType === 'super-admin') {
  //     isSuperAdmin = true
  //   } else {
  //     isSuperAdmin = false
  //   }
  //   return {
  //     installmentData,
  //     installmentplanstatus,
  //     isSuperAdmin,
  //   }
  // },
  created() {
    EventBus.$on('refreshInstallmentPlan', () => {
      this.getInstallmentPlans()
    })
  },
  methods: {
    async fetchInitialData() {
      await this.getPaymentApiSettings()
      await this.getIsSuperAdmin()
      await this.getSenderEmail()
      await this.getTemplateId()
      await this.getCommunicationsApiSettings()
      await this.getDetails()
    },
    isWithin24HoursFunction(date) {
      const currentDate = new Date()
      const targetDate = new Date(date.replace(' ', 'T'))

      const diffInMs = currentDate - targetDate

      const diffInHours = diffInMs / (1000 * 60 * 60)

      return diffInHours <= 24 && diffInHours >= 0
    },
    async getDetails() {
      this.caseId = this.$route.params.id
      // this.loader = true
      const caseDetails = await axios.get(`${constants.baseUrl}/get-debt-case/${this.caseId}`)
      if (caseDetails.data.status) {
        this.journal_id = caseDetails.data.data.debt_case.bc_case_id
      }
    },
    async getCommunicationsApiSettings() {
      await axios.get('/settings/get?module=communication').then(settings => {
        if (settings.status) {
          this.communications_client_id = settings.data.data.client_id
          this.communications_secret = settings.data.data.secret
          this.getSenderEmail()
        }
      }).catch(err => {
        if (err.response.data.message) {
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    getTemplateId() {
      axios.get('/settings/get-default-action-template?action_id=13').then(settings => {
        if (settings.status) {
          this.generate_signature_link_email_template_id = settings.data.data.template_id
        }
      })
    },
    getSenderEmail() {
      const headers = {
        clientId: this.communications_client_id,
        secret: this.communications_secret,
      }
      axios.get(`${constants.communicationBaseUrlV1}/email/get-user-mail-configs`, {
        headers,
      }).then(response => {
        if (response.status) {
          this.sender_email = response.data.data.mail_from_address
        }
      }).catch(err => {
        if (err.response?.data?.message) {
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    async sendLink() {
      await axios.post(`${constants.paymentsBaseUrl}/installment_plan/generate_signature_link`, {
        journal_id: this.journal_id,
        sender_email: this.sender_email,
        generate_signature_link_email_template_id: this.generate_signature_link_email_template_id,
      }).then(response => {
        if (response.status) {
          this.$swal({
            icon: 'success',
            title: 'Email Sent!',
            text: 'Email has been sent successfully.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.getInstallmentPlans()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    getIsSuperAdmin() {
      if (this.userType === 'super-admin') {
        this.isSuperAdmin = true
      } else {
        this.isSuperAdmin = false
      }
    },
    async getPaymentApiSettings() {
      await axios.get('/api-token/default?module=payments').then(settings => {
        if (settings.status) {
          // TODO: Need tot use these values outside this function
          this.payment_client_id = settings.data.data.client_id
          this.payment_secret = settings.data.data.secret
          this.getInstallmentPlans()
        }
      })
    },
    async getInstallmentPlans() {
      const headers = {
        clientId: this.payment_client_id,
        secret: this.payment_secret,
      }
      await axios.get(`${constants.paymentsBaseUrl}/installment_plan/get_installments?journal_id=${this.caseId}`, {
        headers,
      }).then(response => {
        if (response.status) {
          this.signature = response.data.data.signature
          this.linkSentDate = response.data.data.plan_signature_link_at
          // this.isWithin24Hours = this.isWithin24HoursFunction(this.linkSentDate)
          this.installmentData = response.data.data.installments_data
          this.installmentplanstatus = response.data.data.plan_status
          this.installmentloader = false
          EventBus.$emit('getInstallmentPlanStatus', this.installmentplanstatus)
        }
      }).catch(() => {
        this.installmentData = []
        this.installmentplanstatus = 404
        this.installmentloader = false
        EventBus.$emit('getInstallmentPlanStatus', this.installmentplanstatus)
      })
    },
    confirmText() {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_REVERT_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.installmentloader = true
          axios.post(`${constants.paymentsBaseUrl}/installment_plan/update_status`, {
            journal_id: this.caseId,
            status: -1,
          }).then(response => {
            if (response.status === 200) {
              this.installmentloader = false
              this.installmentplanstatus = 3
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: i18n.t('DEBTIA_PLAN_CANCELLATION_SUCCESS'),
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.getInstallmentPlans()
              this.getDetails()
              EventBus.$emit('refreshClientSection')
              EventBus.$emit('refreshStateData')
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.scroll-div-installment {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 400px;
  padding-right: 10px;
}

.scroll-div-installment::-webkit-scrollbar {
    width: 12px;
}

.scroll-div-installment::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div-installment::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
.orange-text {
  color: orange;
}

</style>
